var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-content"},[_c('img',{staticClass:"footer-logo",attrs:{"src":require("@/assets/cryptopag-logo1.png"),"alt":"Logo"}}),_c('p',{staticClass:"footer-copyright"},[_vm._v("©2026 All rights reserved.")])])])])
}]

export { render, staticRenderFns }